import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employees')({
  staticData: { breadcrumb: 'Employees', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEES' },
});
